const stepList =  [
    { count: 3, label: '접수' },
    { count: 2, label: '조제' },
    { count: 5, label: '탕전' },
    { count: 1, label: '포장' },
    { count: 3, label: '배송' }
]

const mediList = [
    { medicine: '약재약재약재약재약재약재약재약재약재약재약재약재', origin: '국내산', quantity: 100 },
    { medicine: '약재', origin: '국내산', quantity: 100 },
    { medicine: '약재', origin: '국내산', quantity: 100 },
    { medicine: '약재', origin: '국내산', quantity: 100 },
    { medicine: '약재', origin: '국내산', quantity: 100 },
    { medicine: '약재', origin: '국내산', quantity: 100 },
    { medicine: '약재', origin: '국내산', quantity: 100 },
    { medicine: '약재', origin: '국내산', quantity: 100 },
    { medicine: '약재', origin: '국내산', quantity: 100 },
    { medicine: '약재', origin: '국내산', quantity: 100 },
]

const wrapperList = [
    { wrapper: '포장지포장지포장지포장지포장지포장지포장지포장지', quantity: 100 },
    { wrapper: '포장지', quantity: 100 },
    { wrapper: '포장지', quantity: 100 },
    { wrapper: '포장지', quantity: 100 },
    { wrapper: '포장지', quantity: 100 },
    { wrapper: '포장지', quantity: 100 },
    { wrapper: '포장지', quantity: 100 },
    { wrapper: '포장지', quantity: 100 },
    { wrapper: '포장지', quantity: 100 },
    { wrapper: '포장지', quantity: 100 },
]

const noticeList =  [
    { title: '공지사항입니다. 공지사항입니다.공지사항입니다. 공지사항입니다 공지사항입니다공지사항입니다공지사항입니다.', date: '2022-03-20' },
    { title: '공지사항입니다.', date: '2022-03-20' },
    { title: '공지사항입니다.', date: '2022-03-20' },
    { title: '공지사항입니다.', date: '2022-03-20' },
    { title: '공지사항입니다.', date: '2022-03-20' },
    { title: '공지사항입니다.', date: '2022-03-20' },
    { title: '공지사항입니다.', date: '2022-03-20' },
    { title: '공지사항입니다.', date: '2022-03-20' },
    { title: '공지사항입니다.', date: '2022-03-20' },
    { title: '공지사항입니다.', date: '2022-03-20' },
]







export { stepList, mediList, wrapperList, noticeList }